import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bb-badges-page-ui',
    templateUrl: './bb-badges-page-ui.component.html',
    styles: [],
    standalone: false,
})
export class BbBadgesPageUiComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
